//@flow
import React from 'react';

const config = {
  title: 'Office Snacking Happiness',
  subtitle: 'Here at NatureBox, we take office snacking pretty seriously. We believe snacks can be crazy delicious but also better for your employees, so they can munch away while focusing on your companies biggest priorities. Snacking, solved!',
  checks: [
    {
      text: 'Healthier snacks',
    },
    {
      text: 'Fixed monthly price - never go over budget',
    },
    {
      text: 'Freedom of choice & variety for all',
    },
    {
      text: 'Free kitchen setup - jars, scoops & trays',
    },
    {
      text: 'Free shipping, every time!',
    },
    {
      text: 'Browse our snacks',
    },
  ],
};

const {title, subtitle, checks} = config;

export default function EasySection() {
  return (
    <div className="easy-section ae-benefits row">
      <div className="row-text md-down">
        {_getRowText("hide-lg-up")}
      </div>
      <div className="checkmark-text-container">
        {_getRowText("hide-md-down")}
        {_getCheckMarkText()}
        <div className="hide-md-down blueberry-img"/>
        <div className="img-container office-snack-img"/>
      </div>
    </div>
  );
}

function _getRowText(className:string) {
  return (
    <div className={`ae-benefits ${className}`}>
      <h2>
        {title}
      </h2>
      <div className="description text-2">
        {subtitle}
      </div>
    </div>
  );
}

function _getCheckMarkText() {
  return (
    <ul className="checkmarks">
      {checks.map((check, index) => (
        <li className="text-3" key={index}>{check.text}</li>
      ))}
    </ul>
  );
}
